module.exports = __webpack_public_path__ + "img/材料力学6_8_1.89dd6024.jpg";